import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

import { Task, BreadcrumbItem } from '../../../entities/index';
import { TaskService } from '../../../services/task.service';
import { Log } from '../../../utils/index';
import Timer = NodeJS.Timer;

@Component({
  selector: 'app-task-detail',
  templateUrl: './task-detail.html'
})
export class TaskDetailComponent implements OnInit, OnDestroy {
  taskId: number;
  fileUrl: any = null;
  fileUrlLoading = false;
  reportUrl: any = null;
  reportUrlLoading = false;
  importTrackerInterval: Timer;
  task: Task = new Task();

  pageTitle = 'Task Detail';
  breadcrumbs: BreadcrumbItem[] = [
    new BreadcrumbItem('Task List', 'cogs', '/task'),
    new BreadcrumbItem('Task Detail', 'cogs')
  ];

  constructor(protected route: ActivatedRoute,
              protected taskService: TaskService,
              private sanitizer: DomSanitizer) {
    this.taskId = Number(route.snapshot.params.id);
    this.pageTitle += ' #' + this.taskId;
    this.breadcrumbs[1].title = this.pageTitle;

  }

  @Log()
  ngOnInit() {
    this.taskService
      .get(this.taskId)
      .subscribe((task: Task) => {
        this.task = task;
        this._initTaskStatusInterval();
      });
  }

  _initTaskStatusInterval() {
    this.importTrackerInterval = setInterval(() => {
      // Prevent refresh of state in next get if the current task is at an end state
      const currentStatus = this.task.status || undefined;
      if (currentStatus && ['SUCCESS', 'ERROR', 'END_WITH_ERRORS'].indexOf(currentStatus) !== -1) {
        this.clearImportInterval();
        return;
      }

      // Refresh task state
      this.taskService.get(this.taskId).subscribe((task: Task) => {
        this.task = task;
        switch (task.status) {
          case 'SUCCESS':
          case 'ERROR':
          case 'END_WITH_ERRORS':
            this.clearImportInterval();
            break;
        }
      });
    }, 10000);
  }

  @Log('blue')
  reportDownloadLink() {
    this.reportUrlLoading = true;

    this.taskService
      .taskImportReport(this.taskId)
      .finally(() => this.reportUrlLoading = false)
      .subscribe((reportUrl: string) => {
        this.reportUrl = this.sanitizer.bypassSecurityTrustUrl(reportUrl);
      });
  }

  @Log('blue')
  fileDownloadLink() {
    this.fileUrlLoading = true;

    this.taskService
      .taskImportFile(this.taskId)
      .finally(() => this.fileUrlLoading = false)
      .subscribe((fileUrl: string) => {
        this.fileUrl = this.sanitizer.bypassSecurityTrustUrl(fileUrl);
      });
  }

  clearImportInterval() {
    if (!!this.importTrackerInterval) {
      clearInterval(this.importTrackerInterval);
    }
  }

  @Log()
  ngOnDestroy() {
    this.clearImportInterval();
    this.fileUrl = '';
    this.reportUrl = '';
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/components/pages/task/task-detail.component.ts